import { styled } from '@mui/system'
import { Alert, Box, Typography } from '@mui/material'

const NotWrapper = styled(Alert)(() => ({
	backgroundColor: '#535660',
	fontFamily: 'Gilroy-Medium, sans-serif',
	fontSize: '1.0625rem',
	fontWeight: 500,
	padding: '12px 23px',
}))
const NotTitle = styled(Typography)(() => ({
	fontSize: '1.0625rem',
	fontWeight: 600,
}))
const NotMessage = styled(Typography)(() => ({
	fontSize: '1rem',
	fontWeight: 500,
	color: 'rgba(255,255,255, 0.7)'
}))
const NotDate = styled(Box)(() => ({
	fontSize: '1rem',
	fontWeight: 500,
	color: 'rgba(255,255,255, 0.9)',
	display: 'flex',
	justifyContent: 'space-between',
}))

export { NotWrapper, NotTitle, NotMessage, NotDate }
